import { array, number, object, SchemaOf, string } from 'yup'

import { RfqEmailFormValues } from '../../models'

export const updateRfqEmailValidationSchema: SchemaOf<RfqEmailFormValues> = object().shape({
  issuerId: number().required(),
  tenantId: number().nullable(),
  instrumentCode: string().nullable(),
  name: string(),
  email: array().of(string().email()),
})
